export default "__VITE_ASSET__BNnjTRmX__"